// The song a station is playing, from its stream metadata (ICY StreamTitle, HLS ID3 TIT2/TPE1).
// Same rules as the mobile apps: artist prefixed when the title lacks it, separators trimmed,
// and titles that only repeat the station name are dropped.
export function cleanStreamTitle(title,artist,stationName){
  let text=String(title||'').replace(/\s+/g,' ').trim();if(!text)return null;
  const by=String(artist||'').replace(/\s+/g,' ').trim();
  if(by&&!text.toLowerCase().includes(by.toLowerCase()))text=`${by} – ${text}`;
  text=text.replace(/^[\s\-–|:]+|[\s\-–|:]+$/g,'');
  return text.length>1&&text.toLowerCase()!==String(stationName||'').trim().toLowerCase()?text:null;
}
// StreamTitle from an ICY metadata block: StreamTitle='Artist - Song';StreamUrl='';
export function icyStreamTitle(block){
  const match=String(block||'').replace(/\0+$/,'').match(/StreamTitle='([\s\S]*?)';(?=\s*(?:[A-Za-z]+=|$))/)||String(block||'').match(/StreamTitle='([^']*)'/);
  return match?match[1]:null;
}
// ICY metadata is usually UTF-8; older servers send Latin-1.
export function decodeIcy(bytes){
  try{return new TextDecoder('utf-8',{fatal:true}).decode(bytes);}catch{return new TextDecoder('latin1').decode(bytes);}
}
// Reads an ICY stream chunk by chunk: `metaint` audio bytes, a length byte (x16), then metadata.
// feed() returns the first non-empty metadata block, '' after two empty ones, else undefined.
// Some servers send an empty first block and the title in the next one, hence two.
export function icyReader(metaint){
  let skipped=0,length=null,parts=[],collected=0,blocks=0;
  return function feed(chunk){
    let at=0;
    while(at<chunk.length){
      if(skipped<metaint){const take=Math.min(metaint-skipped,chunk.length-at);skipped+=take;at+=take;continue;}
      if(length===null){
        length=chunk[at++]*16;
        if(!length){if(++blocks>=2)return '';skipped=0;length=null;}
        continue;
      }
      const piece=chunk.subarray(at,at+length-collected);parts.push(piece);collected+=piece.length;at+=piece.length;
      if(collected>=length){
        const block=new Uint8Array(collected);let offset=0;for(const part of parts){block.set(part,offset);offset+=part.length;}
        return decodeIcy(block);
      }
    }
  };
}
// Title and artist from an ID3v2 tag (HLS timed metadata). Only text frames are read.
export function id3Title(bytes){
  const data=bytes instanceof Uint8Array?bytes:new Uint8Array(bytes||[]);
  if(data.length<10||data[0]!==0x49||data[1]!==0x44||data[2]!==0x33)return null;
  const version=data[3],syncsafe=i=>(data[i]&0x7f)<<21|(data[i+1]&0x7f)<<14|(data[i+2]&0x7f)<<7|(data[i+3]&0x7f);
  const end=Math.min(data.length,10+syncsafe(6));let at=10,title=null,artist=null;
  if(data[5]&0x40)at+=version===4?syncsafe(10):((data[10]<<24|data[11]<<16|data[12]<<8|data[13])>>>0)+4;
  while(at+10<=end&&data[at]){
    const id=String.fromCharCode(...data.subarray(at,at+4));
    const size=version===4?syncsafe(at+4):(data[at+4]<<24|data[at+5]<<16|data[at+6]<<8|data[at+7])>>>0;
    const body=data.subarray(at+10,Math.min(end,at+10+size));at+=10+size;
    if((id!=='TIT2'&&id!=='TPE1')||!body.length)continue;
    const encoding=body[0],raw=body.subarray(1);
    const text=(encoding===1||encoding===2?new TextDecoder(encoding===1?'utf-16':'utf-16be'):new TextDecoder(encoding===3?'utf-8':'latin1')).decode(raw).replace(/\0[\s\S]*$/,'').trim();
    if(id==='TIT2')title=text;else artist=text;
  }
  return title?{title,artist}:null;
}
